export default {
  hsk_left_time: 'Оставшееся время экзамена',
  hsk_submit_paper: 'Отправить тест',
  hsk_not_finished: 'Не завершено',
  hsk_not_start: 'Не начато',
  hsk_finished: 'Завершённые',
  hsk_if_test: 'Ваш предыдущий экзамен еще не завершен. Хотите продолжить?',
  hsk_start_again: 'Начать заново',
  hsk_go_on: 'Продолжить экзамен',
  hsk_if_save: 'Вы уверены, что хотите выйти из пробного экзамена? Ответы будут сохранены, и вы сможете продолжить с того же места позже.',
  hsk_login_filed: 'Срок действия вашей учетной записи истек, ваши ответы не будут сохранены.',
  hsk_report: 'Отчет об ответах',
  hsk_point: 'баллов',
  hsk_qualified_point: 'Сдано при {points} баллах',
  hsk_part1: 'Часть {part}',
  hsk_accuracy1: 'Точность',
  hsk_test_again: 'Пройти еще раз',
  hsk_example: 'Пример',
  hsk_example_eg: 'Пример',
  hsk_answer_analysis: 'Анализ ответа:',
  hsk_your_answer: 'Ваш ответ:',
  hsk_audio_text: 'Текст аудирования:',
  hsk_correct_answer: 'Правильный ответ:',
  hsk_listen_name: 'Аудирование',
  hskk_listen_name: 'Проверка оборудования',
  hsk_read_name: 'Чтение',
  hsk_write_name: 'Письмо',
  hsk_reference_answer: 'Эталонный ответ:',
  hsk_reference_answer_hskk: 'Аудиосодержание задания:',
  hsk_submit_msg: 'Вы уверены, что хотите сдать работу?',
  hsk_homework_no_answer: 'Без ответа',
  hsk_practice_sava: 'Вы уверены, что хотите выйти из тренировки? Ответы не будут сохранены.',
  hsk_practice_go: 'Перейти к тренировке',
  hsk_practice_part: 'Тренировочный модуль',
  hsk_practice_operate: 'Действие',
  hsk_practice_check: 'Просмотреть',
  hsk_practice_num1: 'Верно',
  hsk_practice_num2: ' вопросов из {totalNum}',
  hsk_preview_listen_msg: 'Сейчас воспроизводится инструкция к тесту. В это время вы можете нажать на номера заданий в аудиокарте, чтобы предварительно просмотреть вопросы аудирования.',
  hsk_preview_listen_prompt: 'Сейчас воспроизводится инструкция к экзаменационной работе. В это время можно просматривать вопросы раздела аудирования. Во время экзамена не обновляйте и не закрывайте страницу, иначе ответы будут потеряны.',
  hsk_enter_next_segment_msg: 'Перейти к следующему разделу?',
  hsk_enter_next_segment_preview: 'Закончить просмотр? После окончания начнется раздел аудирования.',
  hsk_enter_next_segment_listen_tip: 'У вас {count} вопросов аудирования без ответа,',
  hsk_enter_next_segment_listen: 'Сдать аудирование? После сдачи раздел будет завершен.',
  hsk_enter_next_segment_listen_review_start: 'Сейчас начался этап проверки аудирования. У вас есть {count} минут для проверки ответов.',
  hsk_enter_next_segment_listen_review: 'Закончить проверку аудирования? После этого начнется раздел чтения.',
  hsk_enter_next_segment_read_tip: 'У вас {count} вопросов по чтению без ответа,',
  hsk_enter_next_segment_read: 'Сдать раздел чтения? После сдачи изменить ответы будет невозможно.',
  hsk_enter_next_segment_write_tip: 'У вас {count} вопросов по письму без ответа,',
  hsk_enter_next_segment_write: 'Подтвердить сдачу экзаменационной работы?',
  hsk_end_preview: 'Закончить просмотр',
  hsk_submit_listen: 'Сдать аудирование',
  hsk_end_review: 'Закончить проверку',
  hsk_start_exam: ' Начать тест',
  hsk_start_exam_new: 'Начать',
  hsk_link_test: 'Нажмите для прохождения полной пробной версии экзамена',
  hsk_link_tips: 'Пройдите полный пробный экзамен, чтобы получить официальный сертификат',
  hsk_buy: 'Купить',
  hsk_test_ready: 'Подготовка к экзамену',
  hsk_test_ready_tips: 'В экзамене есть раздел аудирования. Пожалуйста, заранее настройте оборудование.',
  hsk_test_content: 'Содержание экзамена',
  hsk_test_num: 'Количество заданий',
  hsk_total_num: 'Общее количество вопросов',
  hsk_test_time: 'Время экзамена',
  hsk_time_total: 'Общее время',
  hsk_test_minute: 'минут',
  hsk_about: 'около',
  hsk_abbreviation: 'Хочу сокращение',
  hsk_determine_ans: 'Начать отвечать?',
  hsk_determine_ans_tips: 'После начала нельзя будет снова просмотреть текст',
  no_data: 'Нет данных',
  hsk_question_number: 'Количество вопросов',
  hsk_test_rate: 'Доля экзамена',
  hsk_right_rate: 'Процент правильных ответов',
  hsk_operation: 'Действие',
  hsk_skip: 'Пропустить',
  hsk_spend: 'Затрачено',
  hsk_cost: 'Затраты',
  hsk_credit: 'Баланс',
  hsk_pay_successfully: 'Оплата прошла успешно',
  hsk_select_amount: 'Выберите сумму пополнения',
  button_common_ok: 'ОК',
  button_common_cancel: 'Отмена',
  change_lang_ok: 'ОК',
  change_lang_cancel: 'Отмена',
  hint_player_loader_error: 'Ошибка воспроизведения аудио',
  hint_common_wait_loading: 'Загрузка ресурсов…',
  button_common_hand_in: 'Сдать',
  test_total_question: 'Всего {count} вопросов',
  test_release: 'Опубликовать',
  test_off_shelf: 'Снять с публикации',
  test_enable: 'Включить',
  test_record: 'Записи пробных экзаменов',
  test_finish_time: 'Время завершения',
  test_paper: 'Экзаменационная работа',
  test_confirm_use: 'Подтвердить включение',
  test_confirm_off_shelf: 'Подтвердить снятие',
  test_has_on_shelf: 'Опубликовано',
  test_un_release: 'Не опубликовано',
  test_un_enable: 'Не включено',
  test_max_score: 'Максимальный балл',
  test_average_score: 'Средний балл',
  test_min_score: 'Минимальный балл',
  test_all: 'Все',
  test_has_practiced: 'Уже выполнено, посмотреть результат',
  test_paper_office: 'Экзаменационная работа снята с публикации!',
  test_complete_introduce: 'Полное описание',
  test_course_link: 'Официальный курс',
  test_about_down_load: 'Загрузка материалов',
  test_pay: 'Оплата',
  mark_answer_user: 'Отвечающий',
  mark_answer_time: 'Время ответа',
  mark_correct_time: 'Время проверки',
  mark_correct_status: 'Статус проверки',
  mark_correct_user: 'Проверяющий',
  mark_correct_option: 'Действие',
  mark_correct_ing: 'Проверяется',
  mark_un_correct: 'Не проверено',
  mark_has_correct: 'Проверено',
  mark_report_tips: 'Примечание: раздел «Письмо» пока не включён в общий балл. {markNumberDesc} заданий будет проверено профессиональными экзаменаторами в течение 48 часов. После проверки общий балл будет обновлён, и вам придет уведомление на email.',
  mark_report_tips_hskk: 'Примечание: задания будут проверены профессиональными экзаменаторами в течение 48 часов. После проверки общий балл будет обновлён, и вам придет уведомление на email.',
  mark_submit_btn: 'Отправить на проверку',
  mark_submit_tips: 'Подтвердить отправку на проверку?',
  mark_back: 'Назад',
  mark_correct_tips: 'Текущая работа уже проверяется, повторная проверка невозможна!',
  mark_correct_person: 'Ручная проверка',
  search_user_message: 'Поиск пользователя',
  mark_current_user: 'Текущий пользователь',
  mark_correct_paper: 'Проверить',
  mark_all_status: 'Все статусы',
  mark_all_level: 'Все уровни',
  mark_overtime: 'Просрочено',
  mark_answer: 'Ответ',
  home_test_registration: 'Регистрация на экзамен',
  home_word_outline: 'Проверка словарного запаса',
  home_online_practice: 'Бесплатный образец',
  home_test: 'Полный пробный экзамен',
  home_page: 'Главная',
  common_text_control_speed: 'Скорость воспроизведения',
  button_common_playback: 'Воспроизвести запись',
  common_text_file_error: 'Ошибка загрузки пакета ресурсов, попробуйте снова',
  common_text_server_error: 'Попробовать снова',
  common_text_none_network: 'Нестабильная сеть',
  button_common_start_over: 'Повторить',
  evaluating_tips_common: 'Запись сильно отличается от текста, пожалуйста, перезапишите',
  evaluate_common_total_score: 'Баллы',
  evaluate_common_training_remain: 'Осталось:',
  evaluate_common_training_readyRcord: 'Подготовка к записи',
  evaluate_common_training_atleast: 'Длительность записи должна быть больше 1 сек.',
  evaluate_common_training_atleast2: 'Длительность записи должна быть больше 2 сек.',
  evaluate_common_training_evaluting: 'Оценивание...',
  evaluating_tips_additionalAndBack: 'В процессе чтения были добавлены или повторены слова, это повлияло на итоговый балл',
  textbook_chioce_word_text_correct_tip: 'Правильный ответ, отлично!',
  textbook_chioce_word_text_error_tip: 'Неверный ответ, продолжайте стараться!',
  textbook_reading_comprehension_stem: 'Чтение с пониманием',
  spc_back_tips: 'Вы уверены, что хотите выйти из тренировки? Ответы не будут сохранены.',
  spc_level_text: 'Тест на уровень',
  spc_capability_assessment: 'Оценка навыков',
  spc_pick_level: 'Выбрать уровень',
  spc_listen: 'Слушать',
  spc_speak: 'Говорить',
  spc_read: 'Читать',
  spc_write: 'Писать',
  spc_translation: 'Перевод',
  spc_result_tips: 'По результатам теста ваш уровень китайского соответствует HSK {level}',
  spc_recommend_test: 'Рекомендуется готовиться к HSK {level} уровня',
  spc_recommend_test1: 'Рекомендуется готовиться к <strong>HSK {level}</strong> уровня',
  spc_again_test: 'Пройти снова',
  spc_where_tips: 'Не уверены в своём уровне китайского?',
  spc_immediate_test: 'Пройти тест сейчас',
  spc_test_content: 'Содержание теста',
  spc_test_content_desc: 'Тест оценивает навыки слушания, говорения, чтения (вслух), письма (ручной ввод или выбор) и перевода. Вопросы зависят от уровня.',
  spc_test_timer: 'Время теста',
  spc_test_timer_desc: 'Около 15 минут, для более высоких уровней требуется больше времени.',
  spc_test_result: 'Результат теста',
  spc_test_result_desc: 'Поможет вам быстро определить уровень и улучшить отдельные навыки',
  vocab_level_word: 'Слова уровня {level}',
  vocab_total_item: 'Всего {total}',
  vocab_search: 'Поиск иероглифа/пиньиня/перевода',
  vocab_all_marked: 'Все',
  vocab_already_marked: 'Отмеченные',
  vocab_unmarked: 'Не отмеченные',
  vocabulary: 'Слово',
  vocab_pinyin: 'Пиньинь',
  vocab_translate: 'Перевод',
  vocab_mark: 'Отметить',
  delete_confirmation: 'Подтвердить удаление слова',
  cancel: 'Отмена',
  del: 'Удалить',
  edit_vocab: 'Редактировать слово',
  save: 'Сохранить',
  add_vocab: 'Добавить слово',
  hanzi: 'Иероглиф',
  num_bihua: 'Количество черт',
  write_demo: 'Демонстрация написания',
  vocab_side: 'Ключ',
  level: 'Уровень',
  see_more: 'Посмотреть больше',
  same_read_word: 'Омонимы',
  samilar_read_word: 'Похожие по звучанию иероглифы',
  add_mark: 'Добавить метку',
  word_team: 'Составить слова',
  instance: 'Пример предложения',
  include_num_char: 'Содержит {total} иероглифов',
  length_diff: 'Длина пиньиня и иероглифов не совпадает',
  add_word_success: 'Слово успешно добавлено',
  add_word_fail: 'Не удалось добавить слово',
  edit_word_success: 'Слово успешно изменено',
  edit_word_fail: 'Не удалось изменить слово',
  del_success: 'Удаление успешно',
  del_fail: 'Не удалось удалить',
  mark_free: 'Можно свободно отмечать, например, как «Освоено»',
  write_word_sentence: 'Составьте предложение по приведённому слову…',
  write_word_artical: 'Напишите короткий текст по приведённому ключевому слову…',
  write_img_artical: 'Напишите короткий текст по приведённой картинке…',
  write_artical_title: 'Введите заголовок статьи…',
  write_artical_content: 'Введите основной текст…',
  my_wallet: 'Мои покупки',
  learn_history: 'История обучения',
  manage: 'Управление пользователями',
  birthday: 'Дата рождения',
  email: 'Электронная почта',
  change_pw: 'Изменить пароль',
  edit_info: 'Редактировать информацию',
  lastName: 'Фамилия',
  firstName: 'Имя',
  gender: 'Пол',
  female: 'Женский',
  male: 'Мужской',
  non_disclosure: 'Не раскрывать',
  change_avatar: 'Сменить аватар',
  preview_avatar: 'Предпросмотр аватара',
  upload_image: 'Загрузить изображение',
  change_image: 'Сменить изображение',
  enter_old_pw: 'Введите старый пароль',
  enter_new_pw: 'Введите новый пароль',
  enter_new_pw_again: 'Введите новый пароль ещё раз',
  forget_pw: 'Забыли пароль',
  recharge: 'Пополнить',
  left_balance: 'Доступный баланс',
  consume_log: 'Ответы на тест',
  recharge_log: 'История покупок',
  consume_time: 'Время расхода',
  consume_source: 'Источник расхода',
  consume_money: 'Сумма расхода',
  total_item_log: 'Всего {total} записей',
  recharge_time: 'Время пополнения',
  recharge_num: 'Количество пополнения',
  recharge_money: 'Сумма пополнения',
  recharge_method: 'Способ оплаты',
  learn_content: 'Содержание обучения',
  total_score: 'Общий балл',
  view_result: 'Посмотреть результат',
  management: 'Управление пользователями',
  give_history: 'История подарков',
  total_recharge: 'Общая сумма пополнений',
  last_login: 'Последний вход',
  give: 'Подарить',
  gifted: 'Подарено',
  give_time: 'Время дарения',
  give_to_person: 'Даритель',
  opera_person: 'Оператор',
  give_to: 'Подарить кому',
  old_password_empty: 'Старый пароль не может быть пустым',
  diff_password: 'Введённые пароли не совпадают',
  change_pw_success: 'Пароль успешно изменён',
  change_pw_fail: 'Не удалось изменить пароль',
  change_info_success: 'Информация успешно изменена',
  change_info_fail: 'Не удалось изменить информацию',
  statistics_center: 'Центр статистики',
  select_recharge_mount: 'Выберите сумму пополнения',
  waiting_pay: 'Ожидание оплаты...',
  has_no_resolve_credit: 'Платёж ещё не получен, попробуйте снова.',
  complete_pay: 'Оплата завершена',
  pay_fail: 'Не удалось оплатить',
  give_success: 'Подарок успешно отправлен',
  give_fail: 'Не удалось отправить подарок',
  change_avatar_success: 'Аватар успешно изменён',
  change_avatar_fail: 'Не удалось изменить аватар',
  enter_family_name: 'Введите фамилию',
  enter_given_name: 'Введите имя',
  log_in: 'Войти',
  log_in_error: 'Ошибка входа',
  email_address: 'Адрес электронной почты',
  invalid_email_address: 'Неверный адрес электронной почты',
  password: 'Пароль',
  password_tip: 'Длина пароля 6-20 символов',
  invalid_password: 'Неверный формат пароля',
  have_account: 'Уже есть аккаунт {text}',
  sign_up: 'Регистрация',
  sign_up_error: 'Ошибка регистрации',
  forget_pw_success: 'Письмо для сброса пароля успешно отправлено',
  forget_pw_error: 'Не удалось отправить письмо для сброса пароля',
  loading: 'Загрузка',
  account_block: 'Аккаунт заблокирован',
  account_block_tip: 'Свяжитесь с администратором вашей школы для получения информации',
  resend_email: 'Отправить письмо снова',
  resend_email_success: 'Письмо отправлено повторно',
  resend_email_error: 'Не удалось повторно отправить письмо',
  i_am: 'Я',
  choose_role: 'Кто вы?',
  choose_role_error: 'Не удалось выбрать роль',
  continue: 'Продолжить',
  learner: 'Студент',
  learner_description: 'Я учу китайский язык',
  teacher: 'Учитель',
  teacher_description: 'Я преподаю китайский язык',
  setup_account_error: 'Не удалось настроить учётную запись',
  tos_link: 'Условия обслуживания',
  privacy_link: 'Политика конфиденциальности',
  email_verified: 'Электронная почта подтверждена!',
  email_verified_tip: 'Спасибо за подтверждение вашей почты.',
  email_verified_error: 'Не удалось подтвердить учётную запись',
  something_wrong: 'Что-то пошло не так',
  retry: 'Повторить',
  guardian_consent_error: 'Не удалось выполнить операцию',
  about_us: 'О нас',
  about_us_new: 'О нас',
  feedback: 'Связаться с нами',
  download: 'Скачать',
  submit: 'Отправить',
  feedback_success: 'Успешно отправлено',
  feedback_error: 'Не удалось отправить',
  logout: 'Выйти',
  my_account: 'Моя учётная запись',
  login_signup: 'Войти / Зарегистрироваться',
  please_enter_content: 'Введите содержание отзыва (обязательно)',
  describe_detail: 'Если вы описываете проблему, пожалуйста, укажите максимально подробную информацию',
  upload_picture: 'Загрузка фото (необязательно, максимум {maxFiles}. Поддерживаются JPG/PNG, до 2Мб за файл)',
  file_error: 'Неверный формат или размер файла',
  file_num_limit: 'Максимум {maxFiles} файлов',
  sure_change_lang: 'Вы уверены, что хотите сменить язык?',
  privacy_policy_text1: 'HSK Mock.com — единственная официально сертифицированная платформа пробных экзаменов Hanban',
  privacy_policy_text2: 'Платформа пробных экзаменов разработана и управляется Wo Hui и Hanban на основе базы заданий HSK и YCT. Предоставляет полное пробное тестирование для подготовки к стандартизированным экзаменам по китайскому языку.',
  privacy_policy_text3: 'Wo Hui Mandarin является официальным партнёром Hanban.',
  privacy_policy_text4: 'Hanban (Hanban Education Technology, Beijing) — это специализированная организация, предоставляющая международные услуги в сфере экзаменов по китайскому языку: разработка, исследование, технологии, проведение экзаменов, продвижение.',
  privacy_policy_text5: 'Wo Hui была основана в 2018 году в Сингапуре компанией EiM International Education Group. Предоставляет техническую поддержку и сервисы для изучающих китайский язык по всему миру. Предлагает разнообразные курсы для студентов и ресурсы для преподавателей.',
  privacy_policy_text6: 'Hanban и Wo Hui имеют прочное сотрудничество, направленное на продвижение изучения китайского языка и создание реалистичной среды экзамена для студентов.',
  level_test: 'Тест на уровень',
  level_test_example: 'Если вы не уверены в своём уровне, пройдите бесплатный быстрый тест, чтобы узнать подходящую цель обучения.',
  download_app_mobile: 'Для лучшего опыта используйте настольную версию hskmock.com или скачайте приложение',
  common_video_failed: 'Ошибка загрузки аудио',
  member_error: 'Ошибка ресурсов!',
  agree_policy: 'Я прочитал(а) и согласен(на) с <u class="strong"><a href="{url}" target="_blank">Пользовательским соглашением</a></u> и <u class="strong"><a href="{userUrl}" target="_blank">Политикой конфиденциальности</a></u>',
  please_check: 'Пожалуйста, подтвердите, что вы согласны с Пользовательским соглашением и Политикой конфиденциальности',
  media_devices_unsupported_browserLabel: 'Рекомендуется установить Google Chrome браузером по умолчанию. Пример для Windows 10: Настройки → Приложения → Приложения по умолчанию → Веб-браузер → Выберите Google Chrome',
  media_devices_help_title: 'Включить микрофон',
  media_devices_help_content: 'Необходимо включить микрофон для записи звука',
  batch_exist_user: '{number} зарегистрированных пользователей',
  batch_and: 'и',
  batch_un_exist_user: '{number} незарегистрированных пользователей',
  batch_from: 'из',
  batch_notes: 'Примечания',
  batch_something: 'Заполните',
  batch_people_number: 'Количество получателей',
  batch_use_number2: 'Расход',
  batch_operation_status: 'Статус операции',
  batch_ing_status: 'В процессе',
  batch_success: 'Успешно',
  batch_failed: 'Не удалось',
  batch_select: 'Пожалуйста, выберите',
  common_to: 'до',
  common_start_time: 'Дата начала',
  common_end_time: 'Дата окончания',
  batch_search_tips: 'Вставьте здесь учётные записи пользователей (разделяйте запятыми, максимум 50 за раз)',
  common_un_exist: 'Не зарегистрирован',
  common_invalid: 'Недействительный',
  batch_all_give: 'Массовый подарок экзаменационных работ',
  batch_single_people: 'Индивидуально',
  batch_all: 'Массово',
  batch_name: 'Название',
  batch_added_credits: 'Количество подарков',
  batch_spent_credits: 'Потрачено',
  batch_account_status: 'Статус аккаунта',
  batch_Added_total: 'Всего подарено',
  batch_spent_total: 'Всего потрачено',
  batch_Remaining: 'Остаток',
  batch_Recipients: 'Получатель',
  batch_Active: 'Активировано',
  batch_search: 'Поиск',
  certificate_details: 'Детали сертификата',
  get_official_mock_certificate: 'Получить официальный пробный сертификат',
  certificate_tips: 'Детали сертификата берутся из вашей личной информации. Пожалуйста, проверьте правильность:',
  country: 'Гражданство',
  select_country: 'Выберите гражданство',
  email_to: 'Сертификат будет отправлен на электронную почту:',
  polyphonic: 'Многозначные иероглифы',
  click_tips: 'Нажмите на номер вопроса, чтобы увидеть ответ',
  download_tips: 'После успешной сдачи экзамена можно скачать сертификат',
  cancel_delete_account: 'Удалить аккаунт',
  cancel_confirm: 'Подтвердить',
  user_apply_delete_account_title: 'Заявка на удаление аккаунта',
  user_apply_delete_account_confirm_tip: 'Подтвердите ваши данные для входа',
  user_apply_delete_account_alwaysTip: 'Вы запросили окончательное удаление вашего аккаунта и связанных с ним данных.',
  user_apply_delete_account_confirm_tip2: 'Перед подачей заявки, пожалуйста, подтвердите вашу личность.',
  user_apply_delete_account_desc: 'Ваш аккаунт {email} используется для входа и для использования <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> и <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2: 'После удаления вы не сможете продолжить использовать этот аккаунт для входа в указанные приложения.',
  user_apply_delete_account_wohui_title: 'Отмена подписки на Wo Hui',
  user_apply_delete_account_hsk_title: 'Баланс HSK MOCK',
  user_apply_delete_account_next_tip: 'Нажмите кнопку "Далее", чтобы подтвердить, что вы прочитали и согласны с вышеизложенным.',
  user_apply_delete_account_next_title: 'Далее',
  user_apply_delete_account_confirm_tip11: 'Отмените подписку перед завершением запроса на удаление аккаунта',
  cancel_delete_ok: 'Хорошо',
  cancel_delete_request_send: 'Отправить запрос',
  user_apply_delete_account_confirm_tip8: 'Когда ваша подписка истечет {date}, ваш аккаунт будет удален навсегда',
  user_apply_delete_account_confirm_tip4: 'Мы отправим письмо на',
  user_apply_delete_account_confirm_tip5: 'для подтверждения, что ваш аккаунт был удален',
  user_apply_delete_account_confirm_tip6: 'Для отмены запроса нажмите "Отменить"',
  user_apply_delete_data_always: 'Вы хотите отменить запрос на окончательное удаление вашего аккаунта и связанных с ним данных?',
  cancel_delete_yes: 'Да',
  cancel_delete_no: 'Отменить',
  user_cancel_delete_success: 'Мы отменили ваш запрос, и ваш аккаунт в HSK Mock не будет удален.',
  user_cancel_subscribe_again: 'Вы можете снова оформить подписку.',
  user_apply_delete_account_confirm_tip9: 'Срок вашей подписки истекает {date}',
  user_apply_delete_account_confirm_tip10: 'Пожалуйста, выберите время для удаления аккаунта',
  user_apply_delete_account_ok_btn_title: 'При истечении срока подписки',
  user_apply_delete_account_now_btn_title: 'Удалить сейчас',
  cancel_out_subscription_abnormal: 'Ошибка подписки пользователя',
  user_apply_delete_account_confirm_tip3: 'У вас есть подписка на Apple, и будет автоматически списана плата. Пожалуйста, отмените подписку на Apple перед продлением',
  user_apply_delete_stripe_tip: 'Ваша подписка Stripe будет автоматически списана с вашей кредитной/дебетовой карты. Пожалуйста, посетите наш сайт',
  user_apply_delete_account_balance: 'Ваш баланс составляет',
  user_apply_delete_account_balance_tip: 'После удаления баланс не будет возвращен.',
  user_apply_delete_account_expire: 'Ваш аккаунт будет удален в течение трех дней',
  my_class_name: 'Мой класс',
  my_class_search: 'Поиск класса',
  my_class_total: 'Всего',
  my_class_people: 'Человек',
  my_class_ci: 'Число участий',
  my_class_number: 'Количество людей',
  my_class_ci_number: 'Количество раз',
  my_class_tips: 'Внутреннее кольцо: распределение HSK и YCT по уровням',
  my_class_tips1: 'Внешнее кольцо: распределение HSK и YCT по уровням',
  my_class_all_class: 'Все классы',
  follow_lesson: 'Посмотреть курс',
  real_paper: 'Пройти реальный симуляционный тест',
  start_answer: 'Начать отвечать',
  edit_message_date: 'Дата',
  edit_message_language: 'Язык',
  edit_message_zh: 'Китайский',
  edit_message_en: 'Английский',
  edit_message_title: 'Заголовок',
  edit_message_content: 'Введите текст',
  edit_message_show: 'Показать',
  edit_message_save_success: 'Сохранено успешно!',
  edit_message_create_success: 'Создано успешно!',
  edit_message_edit1: 'Редактировать',
  edit_message_follow_notice: 'Посмотреть уведомление',
  edit_message_textarea_tips: 'Если добавляете ссылку, добавьте пробел после нее для отделения',
  edit_message_notifications: 'Редактировать уведомления',
  edit_message_Send_time: 'Время отправки',
  edit_message_edit_notification: 'Редактировать уведомление',
  edit_message_add: 'Добавить уведомление',
  edit_message_from: 'Начальная дата',
  edit_message_to: 'Конечная дата',
  edit_message_new_add: 'Новое уведомление',
  currency: 'Выбор валюты',
  pay_failed: 'Страница не загрузилась успешно?',
  pay_un_finished: 'Не удалось завершить оплату',
  select_currency_tips: 'Если хотите, можете выбрать валюту из выпадающего списка ниже',
  change_currency_tips: 'Вы всегда можете изменить предпочитаемую валюту в "Мой аккаунт".',
  my_homework: 'Мои домашние задания',
  my_homework_add: 'Назначить задание',
  my_homework_all_classes: 'Все классы',
  my_homework_paper: 'Название теста',
  my_homework_sent_to: 'Отправлено',
  my_homework_sent_on: 'Время отправки',
  my_homework_due_on: 'Крайний срок',
  my_homework_submitted_assignees: 'Количество отправленных/принятых заданий',
  my_homework_class_hint: 'Иконка вокруг названия класса означает, что задание было назначено только части студентов',
  my_homework_delay_hint: 'Показывает, разрешено ли учащимся отправить задание после указанного срока',
  my_homework_add_send_assignment: 'Отправить задание',
  my_homework_add_new_assignment: 'Опубликовать задание',
  my_homework_edit_assignment: 'Редактировать задание',
  my_homework_add_assignment: 'Добавить задание',
  my_homework_add_assignment_details: '1. Детали задания',
  my_homework_add_issue_time: 'Время публикации',
  my_homework_add_whether_submit: 'Разрешить отправку после крайнего срока',
  my_homework_add_note: 'Примечания',
  my_homework_add_assignees: '2. Получатели',
  my_homework_edit_add_assignees: 'Получатели',
  my_homework_add_group: 'Выбор курса',
  my_homework_add_immediate_release: 'Опубликовать немедленно',
  my_homework_add_time_release: 'Запланировать публикацию',
  my_homework_add_are: 'Да',
  my_homework_add_no: 'Нет',
  my_homework_detail_back: 'Вернуться к моим заданиям',
  my_homework_detail_sent_to: 'Отправлено',
  my_homework_detail_leamers_in: 'студентов в',
  my_homework_detail_on: 'на',
  my_homework_detail_to_complete_by: 'Завершено до',
  my_homework_detail_add_assignee: 'Добавить получателя',
  my_homework_detail_assignee: 'Получатель',
  my_homework_search_placeholder: 'Введите поисковый запрос',
  my_homework_stu_sent_by: 'Отправитель',
  my_homework_total_topic_count: 'Всего {count} заданий',
  my_homework_time_full: '{min} минут',
  my_homework_select_date_time: 'Выберите дату и время',
  my_homework_delete_assignment_title: 'Удалить задание',
  my_homework_delete_assignment_tips: 'Вы уверены, что хотите удалить задание? После удаления отменить нельзя!',
  my_homework_assignment_add_fail: 'Не удалось опубликовать!',
  my_homework_assignment_add_success: 'Успешно опубликовано!',
  my_homework_assignment_edit_success: 'Успешно отредактировано!',
  my_homework_assignment_edit_fail: 'Ошибка редактирования!',
  my_homework_assignment_delete_fail: 'Ошибка удаления!',
  my_homework_assignment_delete_success: 'Успешно удалено!',
  my_homework_assignment_due_on: 'Срок сдачи',
  my_homework_assignment_product: 'Название товара',
  my_homework_assignment_certificate: 'Сертификат',
  my_homework_assignment_reset: 'Сбросить',
  my_homework_assignment_reset_title: 'Сбросить выбранный модуль?',
  my_homework_assignment_gifted: 'Количество подарков',
  my_homework_assignment_papers: 'Экзаменационные листы',
  my_homework_assignment_send_to: 'Отправить задание в',
  my_homework_assignment_close_tip: 'Текущее задание ещё не сохранено. Вы уверены, что хотите выйти?',
  pay_callback_tips:
    'Если вы находитесь в материковом Китае, но не являетесь гражданином Китая, мы рекомендуем использовать карты Visa или MasterCard. Мы работаем над решением, которое позволит вам использовать WeChat, Alipay и UnionPay.',
  no_available_class: 'Нет доступных классов для выбора',
  payment_method: 'Способ оплаты',
  wechat_pay: 'Оплата через WeChat',
  alipay_payment: 'Оплата через Alipay',
  card_payment: 'Оплата картой',
  card_payment_description: 'Только для зарубежных банковских карт',
  payment_to_wohui: 'Оплата в 我会我汇我慧科技（上海）有限公司',
  order_submitted: 'Заказ успешно оформлен, пожалуйста, оплатите как можно скорее!',
  order_number: 'Номер заказа:',
  code_expires:
    'QR-код истечёт через <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: 'Пожалуйста, используйте WeChat для сканирования QR-кода и оплаты',
  code_expired: 'Текущий QR-код недействителен',
  amount_payable: 'Сумма к оплате:',
  use_code: 'Использовать код активации',
  tests: 'История экзаменов',
  level_title: 'Какой уровень вы хотите достичь?',
  level_des:
    'Если не уверены, нажмите <b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">Бесплатное определение уровня ></b>',
  level_HSK_text1: '<b>HSK</b> — это сокращение от «Hanyu Shuiping Kaoshi», что означает экзамен по китайскому языку.',
  level_HSK_text2: 'Это самый популярный экзамен по китайскому языку в мире.',
  level_YCT_text1: '<b>YCT</b> — это сокращение от «Youth Chinese Test»,',
  level_YCT_text2: 'что означает экзамен по китайскому для школьников.',
  level_PRIMARY: 'Начальный',
  level_BEGINNER: 'Начальный',
  level_INTERMEDIATE: 'Средний',
  level_ADVANCED: 'Продвинутый',
  level_dialog_title: 'Тест на определение уровня',
  level_dialog_content:
    'Бесплатный тест занимает около 15 минут. Результаты покажут ваш текущий уровень HSK, а также степень владения четырьмя языковыми навыками (аудирование, чтение, письмо, говорение).',
  level_dialog_login: 'Войти / Зарегистрироваться',
  level_dialog_start: 'Начать тест',
  about_us_first_paragraph:
    '<b>HSK Mock</b> — это единственная официальная платформа для пробных экзаменов HSK и YCT. Она создана в сотрудничестве <b>汉考国际</b> и <b>我会中文</b>.',
  about_us_second_paragraph:
    '<b>汉考国际</b> (CTI) — экзаменационный комитет HSK и YCT. Компания со штаб-квартирой в Пекине, которая способствует изучению и преподаванию китайского языка по всему миру.',
  about_us_third_paragraph:
    '<b>我会中文</b> — официальная онлайн-платформа для курсов и экзаменов HSK и YCT. Компания со штаб-квартирой в Сингапуре, использует технологии для того, чтобы студенты учились самостоятельно, а учителя могли оказывать поддержку.',
  about_us_cti_text: 'Узнать больше:',
  about_us_wohui_text: 'Для получения дополнительной информации свяжитесь с:',
  listening_section: 'Раздел аудирования',
  reading_section: 'Раздел чтения',
  writing_section: 'Раздел письма',
  review_answers: 'Проверить ответы',
  characters_long: 'Если вы ещё не зарегистрированы, задайте пароль длиной от 6 до 20 символов.',
  complete_profile: 'Заполнить профиль',
  verify_email: 'Подтвердите адрес электронной почты',
  link_sent: 'Спасибо за регистрацию. Пожалуйста, перейдите по ссылке, отправленной на вашу почту, чтобы подтвердить адрес:',
  resend_link: 'Отправить ссылку ещё раз >',
  restart: 'Перезапустить',
  parental_consent: 'Согласие родителей',
  sent_parental: 'Спасибо за регистрацию. Пожалуйста, следуйте инструкциям в письме, чтобы получить согласие родителей или опекуна:',
  thank_you: 'Спасибо!',
  or_return: 'или вернуться в программу',
  child_profile: 'Профиль вашего ребёнка',
  sign_up_privacy:
    'Я прочитал(а) и согласен(на) с <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">«Условиями обслуживания»</a> и <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">«Политикой конфиденциальности»</a>',
  give_consent: 'Я согласен(на)',
  delete_child_details: 'Удалить данные ребёнка',
  account_created: 'Учётная запись создана',
  emailed_know: "Мы отправили письмо на <span style='font-weight: 700'>{email}</span>, чтобы уведомить их.",
  account_deleted: 'Учётная запись удалена',
  child_know_deleted: 'Сообщите вашему ребёнку, что его данные были удалены.',
  request_email:
    'Вся указанная информация (кроме адреса электронной почты) может быть изменена после входа в систему. Пожалуйста, согласитесь на создание учётной записи для ребёнка или попросите нас удалить данные.',
  preferred_currency: 'Предпочитаемая валюта',
  parent_guardian: 'Родитель / Опекун',
  class_name: 'Название класса',
  // start
  tofficial_platform: 'Единственная официальная платформа для пробного экзамена HSK',
  tofficial_platform_new: 'Официальная платформа для пробного экзамена HSK',
  proficiency_tests: 'Подготовьтесь к самому популярному экзамену по китайскому языку в мире',
  proficiency_tests_new: 'Полные пробные тесты, профессиональное оценивание, усиление словарного запаса и умные тренировки для эффективной подготовки',
  get_started: 'Начать использование',
  get_started_new: 'Начать',
  start_practicing: 'Начать практику',
  get_ready: 'Готовьтесь к HSK уже сегодня!',
  real_hsk_exam_content: 'Полные пробные тесты',
  real_hsk_exam_desc: 'Практикуйтесь с реальными тестами, готовьтесь эффективно и уверенно сдавайте экзамен.',
  official_level_scoring: 'Профессиональное оценивание',
  official_level_scoring_desc: 'Оценка по официальным стандартам HSK, результат надёжен и авторитетен.',
  vocabulary_boost: 'Усиление словарного запаса',
  vocabulary_boost_desc: 'Используйте бесплатные карточки и умные тренировки, чтобы легко запомнить каждое слово!',
  get_hsk_ready: 'Полное руководство по подготовке к HSK',

  how_it_works: 'Как это работает',
  choose_your_level: 'Выберите уровень',
  choose_your_level_desc: 'Выберите подходящий уровень экзамена — от HSK 1 до HSK 9.',
  practise_and_learn: 'Учись и проходи тесты',
  practise_and_learn_desc: 'Начни с бесплатной тренировки словарного запаса! Обнови аккаунт, чтобы разблокировать полный доступ к официальным пробным экзаменам HSK и интеллектуальной системе оценивания.',
  track_your_progress: 'Отслеживай прогресс',
  track_your_progress_desc: 'После каждого теста смотри результаты по всем разделам, следи за своим прогрессом, понимай направления для улучшения и эффективно планируй подготовку.',

  got_questions: 'Есть вопросы? У нас есть ответы',
  faq: 'Часто задаваемые вопросы',
  faq_desc: 'Часто задаваемые вопросы о подготовке к HSK и платформе HSK Mock.',
  faq_btn: 'Посмотреть FAQ',

  blog: 'Блог',
  blog_desc: 'Читайте наш блог, чтобы узнать советы по подготовке к HSK.',
  blog_btn: 'Перейти в блог',

  contact: 'Свяжитесь с нами',
  contact_desc: 'Нужна персональная помощь? Если у вас есть вопросы, свяжитесь с нашей службой поддержки.',
  contact_btn: 'Связаться с нами',

  mock_tests: 'Пробные экзамены',
  blog_and_faq: 'Блог и FAQ',
  real_results_from_real_learners: 'Реальные отзывы, реальные результаты',
  support: 'Поддержка и помощь',
  choose_your_hsk_level: 'Выберите свой уровень HSK',
  choose_your_hsk_level_desc: 'Готовьтесь к HSK, HSK устному экзамену и YCT с помощью официальных пробных тестов и интеллектуальных инструментов.',

  hsk_levels: 'HSK',
  hsk_speaking: 'HSK устный экзамен',
  yct: 'YCT',
  // hsk3.0
  hsk_levels_tri: 'HSK 3.0',

  start_learning: 'Начни учиться прямо сейчас!',
  for_institutions: 'Для школ и образовательных организаций',

  for_hsk3_condidates: 'Для кандидатов на HSK 3',
  for_hsk4_condidates: 'Для кандидатов на HSK 4',
  for_hsk56_condidates: 'Для кандидатов на HSK 5–6',
  // end
  platform_china: 'Эта платформа также доступна для кандидатов из материкового Китая.',
  take_confidence: 'Сдавайте HSK с уверенностью',
  practice_tests: 'Практика HSK и YCT',
  using_time:
    'Используйте последние официальные экзаменационные материалы, знакомьтесь с типами заданий, осваивайте требования экзамена, повышайте скорость выполнения заданий и успешно сдавайте экзамен.',
  instant_results: 'Мгновенная обратная связь',
  each_test_question:
    'Просматривайте каждое выполненное задание: вы увидите свой результат, подробности решения и правильные ответы. Понимайте свои ошибки, исправляйте их и двигайтесь к успеху.',
  track_progress: 'Записывай прогресс',
  ready_next_test:
    'Платформа автоматически фиксирует дату и время каждого пробного экзамена, а также ваш прогресс и изменения в результатах. Эти записи помогут определить лучшее время для реального экзамена, чтобы достичь максимальных результатов.',
  receive_official_certificates: 'Получите официальный сертификат',
  certificates_provide_evidence:
    'Каждый успешно пройденный пробный экзамен подтверждается сертификатом, который демонстрирует ваш уровень владения китайским языком.',
  ready_next_level: 'Готовьтесь к следующему уровню',
  check_description:
    'Читайте описание следующего уровня, чтобы понимать свои цели. Освежите в памяти требования экзамена, повторите словарь, ознакомьтесь с заданиями и улучшите свои навыки.',
  on_the_move: 'Используете мобильное устройство?',
  on_the_move_new: 'Скачайте приложение HSK Mock,',
  download_mobile: 'Нажмите на кнопку ниже, чтобы скачать приложение',
  download_mobile_new: 'Готовьтесь к HSK в любое время и в любом месте.',
  footer: 'HSK Mock — это официальная платформа для пробных экзаменов HSK, объединяющая полные тесты, профессиональное оценивание, словарные тренировки и умные упражнения для эффективной подготовки.',
  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span> — это сокращение от «Hanyu Shuiping Kaoshi», что означает экзамен по китайскому языку. Это самый популярный тест по китайскому в мире. Существует 9 уровней — от начального до продвинутого.',
  more: 'Больше >',
  more_menu: 'Узнать больше',
  ytc_beginner_advanced:
    "<span style='font-weight: 700'>YCT</span> — это сокращение от «Youth Chinese Test», экзамена по китайскому для школьников. Существует 4 уровня — от начального до среднего.",
  coming_end: 'В конце 2023 года будет запущен устный пробный экзамен',
  candidates_proficiency_speaking: 'Этот экзамен проверяет способность кандидатов говорить по-китайски.',
  level_oral_tests:
    "<span style='font-weight: 700'>HSKK</span> — это сокращение от «Hanyu Shuiping Kouyu Kaoshi», что означает экзамен по устному китайскому.",
  check_test_dates: 'Посмотреть даты экзаменов',
  book_test: 'Зарегистрироваться на экзамен',
  international_platform:
    'Китайская платформа находится в материковом Китае; международная — в Сингапуре. Эти платформы независимы друг от друга. Пожалуйста, выберите подходящую.',
  mock_platform: 'Официальная платформа для пробных экзаменов',
  home_proficiency_tests: 'Готовьтесь к самому популярному тесту по китайскому языку',
  currency_type: 'Выбор валюты',
  Pick_your_level: 'Выберите свой уровень',
  About_this_level: 'Описание уровня',
  test_session: 'Тестовая сессия',

  Learning_resources: 'Учебные ресурсы',
  Take_practice_test: 'Пробный экзамен',
  Compare_syllabuses: 'Сравнить учебные программы',
  table_shows_syllabuses: 'Эта таблица показывает уровни HSK в разных программах.',
  forrgin_lang: '0547 — «Китайский язык как иностранный»',
  Second_Language: '0523 — «Китайский язык как второй язык»',
  Requirement_entry: 'Условия регистрации',
  most_Chinese_universities: 'Большинство китайских университетов',
  Qing_Hua: 'Цинхуа университет',
  beijing_university: 'Пекинский университет',
  working_towards: 'После теста рекомендовано готовиться к',
  On: 'На',
  Level_test: 'Тест на уровень',
  Retake_level_test: 'Пересдать тест',
  practice_test: 'Пройти пробный экзамен',
  Compare_syllabuses_a: 'Сравнение разных учебных программ и HSK',
  Not_sure: 'Не уверены в своём уровне?',
  free_level_test: 'Пройдите бесплатный тест на уровень',
  Examples: 'Примеры',
  product_code: 'Код продукта',
  enter_paper: 'Введите код, чтобы пройти тест',
  no_code: 'Нет кода? Пожалуйста, приобретите его у наших партнёров:',
  to_partner: 'Перейти к партнёру',
  code_here: 'Введите код здесь',
  start_assigment: 'Начать',
  view_assigment: 'Посмотреть результаты',
  continue_assigment: 'Продолжить',
  choose_method: 'Выберите способ разблокировки',
  choose_new_method: 'Пожалуйста, выберите способ разблокировать новый тест.',
  browser_layer: 'Используйте Google Chrome на ПК или приложение на мобильном устройстве',
  partner_title1: 'Мы хотим, чтобы вы стали',
  partner_title2: 'нашим локальным партнёром',
  company_name: 'Название компании',
  company_website: 'Веб-сайт компании',
  teachers_count: 'Количество учителей HSK, сотрудничающих с вами',
  learners_count: 'Количество студентов HSK, сотрудничающих с вами',
  add_msg: 'Оставьте нам сообщение',
  contact_style: 'Как с вами связаться?',
  send: 'Отправить',
  partner_forms_desc:
    'В качестве нашего локального партнёра вы станете основным контактом для кандидатов, учителей, школ и университетов в вашей стране или регионе.<br><br>Наши партнёры обычно являются центрами HSK-экзаменов и подготовки, которые хотят расширить бизнес и повысить официальный статус.<br><br>Если вы хотите стать партнёром, войдите в свой личный HSK Mock аккаунт <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">и заполните форму</span>, мы свяжемся с вами в ближайшее время.',
  submit_success: 'Успешно отправлено',
  help_students_for_testing: 'Вы помогаете студентам готовиться к экзаменам?',
  help_students_for_testing_desc:
    'Учителя играют ключевую роль в достижении студентами новых целей.<br>Мы предоставляем учителям инструменты для индивидуальной поддержки студентов.',
  become_partner: 'Станьте нашим партнёром',
  become_partner_desc:
    'Для кандидатов важно иметь возможность связаться с экзаменационным центром на родном языке и оплачивать экзамен удобным локальным способом.',
  partnership: 'Изучить возможности сотрудничества',
  students_forward: 'Помогите своим студентам двигаться вперёд',
  hsk_confidence: 'Сдавайте HSK с уверенностью',
  try_it_out: 'Попробовать прямо сейчас',
  walk_through: 'Ознакомьтесь с процессом экзамена',
  teachers_page_desc1:
    'Функционал платформы поддерживает как групповое, так и индивидуальное обучение. Позволяет студентам знакомиться с типами заданий, повторять словарь, просматривать экзаменационный контент и осваивать экзаменационные навыки.',
  assign_practice_papers: 'Установите дату и время сдачи пробной работы',
  teachers_page_desc2:
    'Разместите тест для своих студентов. Вы можете использовать пробные тесты как имитацию настоящего экзамена, чтобы помочь студентам освоить разные типы заданий и уложиться в отведённое время.',
  get_instant_results: 'Мгновенная проверка результатов',
  teachers_page_desc3:
    'Учителям не нужно проверять тесты вручную. Просматривайте, сдали ли студенты назначенные работы, и смотрите результаты каждого ученика.',
  review_their_answers: 'Анализ ответов студентов',
  teachers_page_desc4:
    'Изучайте результаты студентов по классам, навыкам, разделам и даже отдельным заданиям. Анализируя ответы, вы сможете выстроить индивидуальный план обучения и дать точечную обратную связь.',
  track_prog: 'Отслеживайте прогресс студентов',
  teachers_page_desc5:
    'Платформа детально фиксирует все результаты экзаменов, показывает ответы по каждому заданию, а также прогресс и изменения в результатах. Это помогает определить, когда студент готов к настоящему экзамену и сможет показать лучший результат.',
  students_next_level: 'Помогите студентам достичь нового уровня',
  teachers_page_desc6:
    'Наша сестринская платформа предоставляет официальные материалы HSK и YCT, а также все необходимые ресурсы для преподавания, чтобы учителя могли индивидуально поддерживать студентов.',
  teaching_resources: 'Учебные материалы',
  for_teachers: 'Для учителей',
  teachers_desc1:
    'Пожалуйста, войдите в платформу HSK Mock со своим личным аккаунтом <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">.</span>',
  teachers_desc2: 'Заполните базовую информацию ниже, и мы откроем бесплатный доступ для вашей школы.',
  school_name: 'Название школы',
  school_web: 'Сайт школы',
  num_of_hsk_teachers: 'Количество учителей HSK',
  num_of_hsk_learners: 'Количество студентов HSK',
  hsk_submit_reading: 'Чтение',
  pay_tip: 'Если вы купили пробные тесты через Alipay или WeChat, используйте сайт материкового Китая hskmock.cn.',
  use_pc_or_app: 'Попробуйте прямо сейчас — войдите с ПК или скачайте приложение.',
  download_certificate: 'Скачать сертификат',
  create_certificate: 'Создать сертификат',
  certificate_is_downloaded: 'Сертификат скачан',
  pay_discount_title: 'Сколько раз вы хотите пройти полный пробный экзамен уровня {level}?',
  total: 'Итого',
  pay: 'Оплатить',
  price_desc:
    'Вы платите только за пробные экзамены. При покупке нескольких экзаменов сразу предоставляется скидка на каждую попытку.',
  the_level: 'Уровень',
  discounted_price: 'Цена со скидкой',
  price_contact_us:
    'Мы также предлагаем массовые закупки для школ и организаций. Пожалуйста, <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">свяжитесь с нами</span>, чтобы обсудить ваши потребности.',
  get_a_discount: 'Получить скидку',
  finished_pay_discount_title: 'Ниже приведены коды для пробных тестов уровня {level_name}.',
  btn_goto_papers: 'Посмотреть тесты уровня {level_name}',
  test_count: '{test_num} экзаменов',
  unit_price: '{price}/экзамен',
  buy_code_tip:
    'Мы отправили эти коды вам по электронной почте. Теперь выберите нужный тест {level_name}, введите код и разблокируйте доступ.',
  discount_codes_left_tip:
    'После окончания теста у вас останется <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count} код(ов)</span> на этом уровне.',

  manage_class: 'Управление классом',
  to_manage_class: 'Система управления классами откроется в новой вкладке. После завершения вернитесь в эту вкладку и обновите страницу.',
  code_used: 'Использован',
  code_can_be_used: 'Не использован',
  no_test: 'Количество',
  history_purchase_quantity: 'Количество',
  hsk_listen_part_title: 'Аудирование, часть {count}',
  hsk_read_part_title: 'Чтение, часть {count}',
  hsk_write_part_title: 'Письмо, часть {count}',
  Description: 'Описание',
  Test_format: 'Формат экзамена',
  Vocabulary: 'Лексика',
  vocab_type: 'Часть речи',
  sso_login_signup: 'Вход / Регистрация',
  sso_email_address: 'Адрес электронной почты',
  sso_password: 'Пароль',
  sso_characters_long: 'Если у вас нет учётной записи, задайте пароль длиной от 6 до 20 символов.',
  sso_forget_pw: 'Забыли пароль',
  sso_agree_policy:
    'Я прочитал(а) и согласен(на) с <u class="strong"><a href="{url}" target="_blank">«Пользовательским соглашением»</a></u> и <u class="strong"><a href="{userUrl}" target="_blank">«Политикой конфиденциальности»</a></u>',
  sso_continue: 'Продолжить',
  sso_please_check: 'Пожалуйста, отметьте, что вы прочитали и согласны с «Пользовательским соглашением» и «Политикой конфиденциальности»',
  sso_invalid_email_address: 'Неверный адрес электронной почты',
  sso_invalid_password: 'Неверный формат пароля',
  sso_loading: 'Загрузка',
  sso_mock_platform: 'Официальная платформа пробных экзаменов',
  sso_home_proficiency_tests: 'Подготовка к самым популярным экзаменам по китайскому языку',
  sso_guardian_consent_error: 'Ошибка операции',
  sso_forget_pw_success: 'Письмо для сброса пароля успешно отправлено',
  sso_forget_pw_error: 'Не удалось отправить письмо для сброса пароля',
  sso_log_in_error: 'Ошибка входа',
  sso_download_app_mobile: 'Для лучшего опыта используйте настольную версию hskmock.com или скачайте приложение',
  sso_no_binding_info_tip: 'Не удалось получить вашу подробную информацию',
  sso_third_login_tip: 'Пожалуйста, выберите сайт для входа',
  sso_third_login_wohui: 'Перейти на Wǒhuì Zhōngwén (Я знаю китайский)',
  sso_third_login_mock: 'Перейти на HSK Mock',
  other_gender: 'Не указано / другое',
  hsk_enter_listening: 'Аудирование',
  intro_msg_first: 'В этом экзамене {num} частей, вы должны пройти их по порядку.',
  intro_msg_second: 'Пожалуйста, завершите каждую часть в установленное время.',
  intro_msg_third:
    'Если вы завершили эту часть до истечения времени, вы можете перейти к следующей, но вернуться назад и продолжить выполнение уже нельзя.',
  dialogue_listening: 'Первая часть — аудирование. Нажмите кнопку для воспроизведения аудиофайла и настройте устройство при необходимости.',
  dialogue_listening_hskk: 'Нажмите кнопку для воспроизведения аудиофайла и настройте устройство при необходимости.',
  dialogue_intro_msg_first:
    'Во время проигрывания музыки будет дана общая информация об экзамене. В это время можно просмотреть задания по аудированию.',
  dialogue_intro_msg_first_hskk:
    'Во время проигрывания музыки будет дана общая информация об экзамене.',
  dialogue_intro_msg_second: 'Для имитации реального экзамена нельзя ставить на паузу, перематывать назад или вперёд аудиофайл части «Аудирование».',
  dialogue_intro_msg_second_hskk: 'Для имитации реального экзамена нельзя ставить на паузу, перематывать назад или вперёд.',
  dialogue_intro_msg_third: 'После окончания аудирования у вас будет {duration} минут на проверку своих ответов.',
  dialogue_intro_question: 'Возникли вопросы?',
  dialogue_preload_intro_first: 'Аудиофайл для части «Аудирование» загружается.',
  dialogue_preload_intro_second: 'После загрузки аудио автоматически начнётся тест.',
  dialogue_preload_intro_third: 'Удачи!',
  dialogue_preload_title: 'Загрузка экзаменационных ресурсов',
  mock_paper_preview: 'Предпросмотр пробного теста',
  dialogue_mock_paper_intro_title: 'Инструкции к экзамену',
  dialogue_mock_paper_intro_sentence1:
    'Экзамен займёт примерно {minutes} минут. Убедитесь, что у вас достаточно времени и заряда устройства для прохождения без перерывов.',
  dialogue_mock_paper_intro_sentence2: 'Экзамен проводится полностью онлайн, убедитесь в стабильности интернет-соединения.',
  dialogue_mock_paper_intro_sentence3:
    'Если вы используете компьютер или ноутбук, пожалуйста, откройте экзамен в последней версии браузера Chrome или Safari.',
  dialogue_mock_paper_intro_sentence4:
    'Если вы используете планшет, пройдите экзамен через наше мобильное приложение, а не через браузер.',
  dialogue_mock_paper_intro_sentence5:
    'Во время экзамена не открывайте другие окна браузера или приложения, не меняйте язык системы и не подключайте/отключайте устройства (например, флешку, наушники и т. д.).',
  diologue_mock_paper_quit: 'Выйти',
  dialogue_mock_paper_intro_button: 'Я прочитал(а) и понял(а)',
  deadline_passed: 'Срок сдачи истёк',
  mock_skip_introduction: 'Пропустить инструкции?',
  Listening: 'Аудирование',
  Reading: 'Чтение',
  Writing: 'Письмо',
  personal_info_display_name_as: 'Имя для отображения в сертификате',
  code_pratice_text: 'Используйте <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> для прохождения <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span> пробного экзамена',
  code_input_text: 'Введите код:',
  use_code_limit: 'Каждый код можно использовать только один раз',
  code_select_text: 'Или выберите код:',
  pay_discounts_desc1: 'Практика на основе реальных экзаменационных заданий прошлых лет поможет вам',
  pay_discounts_desc2: 'достичь лучших результатов на экзамене [{type}] [{level}]',
  pay_discounts_desc3: 'Купи один — получи один бесплатно',
  pay_discounts_desc4:
    'Если вы зарегистрировались на официальный экзамен [{type} {level}], вы можете воспользоваться акцией «Купи один — получи один бесплатно» при покупке пробных тестов [{type} {level}].',
  pay_discounts_desc5: 'Сколько пробных тестов вы хотите приобрести?',
  level_HSKK_text1: 'Экзамен HSKK оценивает устные навыки китайского языка. Он включает три уровня: начальный, средний и высокий.',
  level_HSKK_text2: 'HSKK проводится в форме записи ответов.',
  level_HSKK_text3: 'Для сдачи HSK3 необходимо пройти HSKK (начальный уровень), для HSK4 — HSKK (средний уровень), а для HSK5 и HSK6 — HSKK (высокий уровень).',
  test_download_desc: 'Пробные тесты этого уровня готовятся. Тем временем скачайте:',
  speaking: 'Говорение',
  Traduction: 'Перевод',
  my_homework_none_homework: 'Для этого уровня пока нет пробных заданий, ожидайте.',
  my_class_none_test: 'Для этого уровня пока нет онлайн-пробных экзаменов, ожидайте.',
  hsk_audio_error: 'Ваше интернет-соединение нестабильно, аудио не удалось загрузить. Пожалуйста, попробуйте снова.',
  mock_join_campus_text1: 'Вы принимаете приглашение присоединиться к сообществу по изучению, преподаванию и сдаче китайского?',
  mock_join_campus_text2: 'После присоединения учителя смогут назначать вам тесты на HSKMock.com или задания на app.wohuimandarin.com.',
  sso_join_campus_text4: 'Учителя смогут просматривать ваши ответы и давать целенаправленную обратную связь.',
  join: 'Присоединиться',
  free_practice_title: 'Бесплатная практика',
  choose_free_practice: 'Выберите метод практики',
  word_flashcards: 'Карточки со словами',
  word_practice: 'Упражнения со словами',
  analyse_text: 'Анализ текста',
  flashcards_title: 'Карточки',
  practice_exercises_title: 'Практические задания',
  analyse_title: 'Анализ',
  practice_result_title: 'Результаты практики',
  generate_flashcards: 'Создать набор карточек',
  generate_practice: 'Создать набор упражнений',
  random_select: 'Случайный выбор',
  manual_select: 'Ручной выбор',
  max_words: 'Максимум {number} слов',
  already_choose: 'Выбрано: {total}',
  free_practice_words_quantifier: 'шт.',
  free_practice_unchoose_question: 'Пожалуйста, выберите тип вопроса',
  free_practice_unchoose_practice: 'Пожалуйста, выберите тип упражнения',
  none_mark_words_hint: 'На данном уровне вы ещё не отметили ни одного слова',
  excceed_max_count: 'Можно выбрать не более {total} слов, достигнут предел',
  free_practice_sound: 'Звук',
  free_practice_question: 'Вопрос',
  free_practice_choose_exercise: 'Выберите тип упражнения',
  free_practice_exercise_select: 'Выбор одного ответа',
  free_practice_exercise_Pairs: 'Соответствие',
  free_practice_exercise_TF: 'Верно / Неверно',
  launch: 'Начать',
  free_practice_check_text: 'Вы ответили правильно?',
  free_practice_timer_pause: 'Пауза таймера',
  free_practice_timer_pause_desc: 'Если не будет активности, таймер автоматически остановится',
  free_practice_seconds: '{number} секунд',
  resume: 'Продолжить',
  flashcard_completed: 'Карточки завершены',
  practice_completed: 'Практика завершена',
  practice_spent_minutes: 'Всего времени: {duration} мин.',
  practice_result_summary: 'Итоговый результат',
  practice_result_progress_txt: 'Вы получили',
  practice_wrong: 'Ошибка',
  practice_skip: 'Пропустить',
  practice_done: 'Завершено',
  analyse_desc_1: 'Анализ текста на основе выбранного словаря',
  analyse_desc_2: 'Вставьте или введите текст на китайском (не более {maxCount} символов)',
  analyse_input_placeholder: 'Введите текст на китайском',
  free_practice_need_word: 'Выберите слова из таблицы или сгенерируйте случайным образом',
  free_practice_exercise_select_title: 'Выберите правильный ответ',
  free_practice_exercise_pairs_title: 'Нажмите, чтобы сопоставить',
  free_practice_exercise_meaning_title: 'Должно означать',
  free_practice_exercise_sound_title: 'Должно звучать как',
  free_practice_exercise_characters_title: 'Должно быть записано как',
  free_practice_show_correct_answers: 'Показать правильные ответы',
  free_practice_show_my_answers: 'Показать мои ответы',
  free_practice_check: 'Проверить',
  free_practice_correct: 'Правильно',
  free_practice_characters: 'Иероглифы',
  hsk_introduce_objective_questions: 'Объективные вопросы',
  hsk_introduce_subjective_questions: 'Субъективные вопросы',
  hsk_input_type_here: 'Введите здесь',
  hsk_translation_part_title: 'Перевод, часть {count}',
  hsk_speaking_part_title: 'Говорение, часть {count}',
  subjective_reading_placeholder: 'Пожалуйста, ответьте на вопросы по тексту выше…',
  hsk_write_by_artical: 'Напишите сочинение по материалу выше…',
  hsk_translation_by_artical: 'Переведите текст выше…',
  hsk_trasnlation_choose_language: 'Далее идёт раздел перевода. Пожалуйста, выберите язык.',
  choose_speaker: 'Выберите динамик',
  choose_microphone: 'Выберите микрофон',
  hsk_is_recording: 'Идёт запись',
  dialogue_speaking: 'Последняя часть — говорение. Убедитесь, что динамик и микрофон работают.',
  start_recording: 'Нажмите, чтобы начать запись',
  hsk_write_count: 'Количество знаков',
  error_access_media: 'Ошибка доступа к устройствам записи.',
  setSinkId_not_supported: 'Ваш браузер не поддерживает {setSinkId}.',
  error_switch_device: 'Ошибка при переключении устройства.',
  translation_section: 'Раздел перевода',
  speaking_section: 'Раздел говорения',
  failed_upload_record: 'Не удалось загрузить аудиозапись. Пожалуйста, попробуйте снова.',
  hsk_enter_next_segment_write_high: 'Отправить сочинение? После отправки изменить его будет нельзя.',
  hsk_enter_next_segment_translate_tip: 'У вас осталось {count} непереведённых заданий,',
  hsk_enter_next_segment_translate: 'Отправить ответы? После отправки раздел перевода будет завершён, возврат невозможен.',
  hsk_enter_next_segment_speaking_tip: 'У вас {count} устных заданий без ответа,',
  Translating: 'Перевод',
  Speaking: 'Говорение',

  back_to_home: 'Вернуться на главную',
  about_us_desc:
    '<b>HSK Mock</b> — это официальная онлайн-платформа для пробных экзаменов <b>HSK</b>, <b>HSK по говорению</b> и <b>YCT</b>. Она воссоздаёт реальные условия экзамена, помогая ученикам уверенно подготовиться, точно оценить уровень и всесторонне улучшить навыки.',
  who_we_are: 'Кто мы',
  who_we_are_desc:
    'HSK Mock создана совместно <b>Hanban International (Chinese Testing International)</b> и <b>«Wo Hui Mandarin»</b>. Наша цель — предоставить изучающим китайский по всему миру надёжные пробные экзамены и обучающие инструменты.',
  why_choose_hsk_mock: 'Почему HSK Mock?',
  about_us_carousel_1: 'Официальная база заданий',
  about_us_carousel_1_content:
    'HSK Mock строго следует структуре заданий официальных экзаменов HSK, HSK по говорению и YCT.',
  about_us_carousel_2: 'Авторитетная система оценки',
  about_us_carousel_2_content:
    'HSK Mock использует такие же стандарты оценки, как и на официальном экзамене, что позволяет объективно определить уровень знаний.',
  about_us_carousel_3: 'Эффективные инструменты обучения',
  about_us_carousel_3_content:
    'HSK Mock также предлагает тренажёры по лексике для разных уровней, что помогает развивать все навыки: аудирование, говорение, чтение и письмо.',
  about_us_carousel_4: 'Гибкость использования на разных устройствах',
  about_us_carousel_4_content: 'HSK Mock доступен как на компьютере, так и на телефоне — занимайтесь где угодно.',
  about_us_carousel_5: 'Выбор учеников со всего мира',
  about_us_carousel_5_content: 'HSK Mock уже помог тысячам учащихся по всему миру достичь своих целей в изучении китайского языка.',

  for_teachers_banner_title: 'Официальная платформа пробных экзаменов, подходящая для школ и международных команд',
  for_teachers_banner_desc: 'Официальная платформа пробных экзаменов HSK объединяет реальные экзаменационные материалы, профессиональное оценивание, тренировку словарного запаса и интеллектуальные упражнения. С помощью HSK Mock можно в любое время и в любом месте онлайн оценить уровень китайского языка и пройти симуляцию настоящих экзаменов HSK и YCT. Это надёжный выбор для международных школ, университетов, HR-команд компаний и специалистов по глобальной мобильности.',
  for_teachers_banner_btn: 'Записаться на демо',

  for_schools: 'Для школ и преподавателей',
  for_schools_desc: 'С помощью официально признанных пробных экзаменов HSK и YCT помочь студентам уверенно готовиться.',
  for_schools_list_1: 'Экзаменационный процесс идентичен официальному, имитация реальной экзаменационной среды',
  for_schools_list_2: 'Поддержка различных устройств, возможность онлайн-тестирования в любое время и в любом месте',
  for_schools_list_3: 'Мгновенное оценивание для HSK уровней 1–3 и YCT уровней 1–4',
  for_schools_list_4: 'Отслеживание прогресса студентов и класса в любое время',

  for_corporates: 'Для компаний и HR-команд',
  for_corporates_desc: 'Гибкая и быстрая оценка китайского языка для ротации сотрудников, командировок, найма и бизнес-задач.',
  for_corporates_list_1: 'Языковой отбор перед командировками и внутреннее тестирование для установления стандарта',
  for_corporates_list_2: 'Мгновенные результаты для HSK уровней 1–3; результаты экзаменов HSK уровней 4–6 доступны в течение 48 часов',
  for_corporates_list_3: 'Отслеживание прогресса после обучения',
  for_corporates_list_4: 'Оценивание онлайн и офлайн, в любое время и в любом месте',

  official_format: 'Официальный формат',
  official_format_desc: 'Симуляция настоящих экзаменов HSK и YCT, воссоздание реальной атмосферы экзамена.',
  smart_scoring: 'Профессиональное оценивание',
  smart_scoring_desc: 'Оценка на основе официальных стандартов.',
  progress_analytics: 'Аналитика прогресса',
  progress_analytics_desc: 'Детальный анализ и отслеживание результатов студентов или команд.',
  remote_access: 'Удалённый доступ',
  remote_access_desc: 'Полностью онлайн, доступно в любое время и в любом месте.',

  why_use_hsk: 'Для кого подходит официальная платформа HSK Mock',
  international_schools: 'Международные школы',
  international_schools_desc: 'Предлагают курсы китайского языка в соответствии со стандартами HSK/YCT и обладают возможностью расширенного оценивания.',
  universities_institutes: 'Университеты и профессиональные учебные заведения',
  universities_institutes_desc: 'Предоставляют официальную поддержку тестирования для академических курсов китайского языка.',
  global_corporates: 'Международные компании',
  global_corporates_desc: 'Оценивают и понимают уровень китайского у сотрудников для позиций, связанных с китайским рынком.',
  language_training_providers: 'Учебные центры',
  language_training_providers_desc: 'Предоставляют учащимся пробные экзамены, соответствующие официальным стандартам.',

  ready_to_access: 'Готовы оценить уровень китайского языка?',
  book_live_demo: 'Запишитесь на живую демонстрацию, получите пробный аккаунт, просмотрите аналитику результатов и быстро начните работать с HSK Mock.',
  book_demo: 'Записаться на демо'
}
